import get from "lodash/get";

import {
  CYPRESS_TEST_COUNT_LOADING,
  CYPRESS_TEST_COUNT_SUCCESS,
  CYPRESS_TEST_COUNT_FAILED,
  TEST_ARCHIVES_SET_IS_SHARE_MODAL_VISIBLE,
  TEST_ARCHIVES_PAGINATION_LOADING,
  TEST_ARCHIVES_PAGINATION_SUCCESS,
  TEST_ARCHIVES_PAGINATION_FAILED,
  CLEAR_ARCHIVES_PAGINATION_DATA,
  DELETE_TEST,
  LAMBDATEST_TEST_LIST_DATA_UPDATE,
  LAMBDATEST_TEST_LIST_DATA_UPDATE_LIST,
  FETCH_FLAXY_TESTS_LIST_SUCCESS,
  LAMBDATEST_RENAME_TEST_SUCCESS,
  LAMBDATEST_UPDATE_TEST_NAME_STATUS,
  TEST_MUTE_STATUS_UPDATE
} from "../actionTypeConstants/TestArchives";
import { deleteObjectById } from "../../utility/utilityFunctions";

const initialState = {
  isLoading: false,
  isTableDataLoading: true,
  isShareModalVisible: false,
  pageNumber: 0,
  sortBy: "newest",
  tests: [],
  testIdToShare: "",
  total: 0,
  filters: {
    range: "",
    browser: [],
    os: [],
    build: [],
    tag: [],
    group: [],
    resolution: []
  },
  flakyTests: {}
};

const TEST_LIMIT = 10;

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAMBDATEST_TEST_LIST_DATA_UPDATE_LIST: {
      const updatedTestData = action.payload;
      const testsList = state.tests || [];
      const newTestlist = testsList.map(test => {
        if (updatedTestData[test.id]) {
          const _test = { ...test, ...updatedTestData[test.id] };
          delete updatedTestData[test.id];
          return _test;
        }
        return test;
      });
      const newList = [
        ...(Object.values(updatedTestData) || []),
        ...newTestlist
      ];
      return {
        ...state,
        tests: newList,
        loading: false
      };
    }

    case LAMBDATEST_TEST_LIST_DATA_UPDATE: {
      const updatedTestData = action.payload;
      const testsList = state.tests || [];
      const testToUpdateIndex = testsList.findIndex(
        ({ id }) => id === updatedTestData.id
      );
      let newList = [...testsList];

      if (testToUpdateIndex === -1) {
        newList = [updatedTestData, ...newList];
      } else {
        const testToUpdate = testsList[testToUpdateIndex];

        const startedAt = updatedTestData.startedAt
          ? updatedTestData.startedAt
          : testToUpdate.startedAt
          ? testToUpdate.startedAt
          : "";

        testToUpdate["status"] = updatedTestData.status;
        testToUpdate["statusInd"] = updatedTestData.statusInd;
        testToUpdate["startedAt"] = startedAt;
        testToUpdate["endedAt"] = get(updatedTestData, ["endedAt"], "");
        newList[testToUpdateIndex] = testToUpdate;
      }

      return {
        ...state,
        tests: newList,
        loading: false
      };
    }

    case TEST_ARCHIVES_PAGINATION_FAILED: {
      const isCancelledState1 = action.error.toString() === "Cancel";
      return {
        ...state,
        isLoading: isCancelledState1,
        error: action.error
      };
    }

    case CLEAR_ARCHIVES_PAGINATION_DATA: {
      return {
        ...state,
        tests: [],
        isLoading: true
      };
    }

    case TEST_ARCHIVES_SET_IS_SHARE_MODAL_VISIBLE:
      const isShareModalVisible = get(action, "payload", false);
      return {
        ...state,
        isShareModalVisible
      };

    case TEST_ARCHIVES_PAGINATION_SUCCESS: {
      const response = get(action, ["result", "data"], {});
      const { tests = [], total = 0 } = response;
      const hasMore = !(tests.length < TEST_LIMIT);
      const additionalData = {};
      const { offset = 0 } = get(action, ["payload"], {});
      if (offset === 0) {
        additionalData["total"] = total;
      }
      return {
        ...state,
        tests: [...state.tests, ...tests],
        isLoading: false,
        hasMore: hasMore,
        pageNumber: offset,
        ...additionalData
      };
    }

    case TEST_ARCHIVES_PAGINATION_LOADING: {
      return {
        ...state,
        isLoading: true
      };
    }

    case FETCH_FLAXY_TESTS_LIST_SUCCESS: {
      const flakyList = get(action, ["result", "data", "data"], []);
      const flakyTests = {};
      flakyList.forEach(test => {
        flakyTests[test.rowName] = test;
      });
      return {
        ...state,
        flakyTests: {
          ...state.flakyTests,
          ...flakyTests
        }
      };
    }

    case DELETE_TEST: {
      return {
        ...state,
        tests: deleteObjectById(state.tests, "id", get(action, ["payload"], ""))
      };
    }

    case LAMBDATEST_UPDATE_TEST_NAME_STATUS: {
      const testData = [...state.tests];
      const { testName = "", testId = "", status = "" } = action?.payload || {};
      const foundIndex = testData.findIndex(test => test.id == testId);
      if (testName) {
        testData[foundIndex]["name"] = testName;
      }
      if (status) {
        testData[foundIndex]["status"] = status;
      }
      return {
        ...state,
        testData: {
          ...state.testData,
          data: testData
        }
      };
    }

    case LAMBDATEST_RENAME_TEST_SUCCESS: {
      let testData = [...state.tests];
      const foundIndex = testData.findIndex(
        test => test.id === action.result.data.data.testId
      );

      testData[foundIndex].name =
        action.result.data.data.name || testData[foundIndex].name;
      return {
        ...state,
        testData: {
          ...state.testData,
          data: testData,
          updatetestName: {
            loading: false,
            data: action.result.data,
            error: null
          }
        }
      };
    }

    case CYPRESS_TEST_COUNT_SUCCESS: {
      const existingTestList = state.tests || [];

      const response = get(action, ["result", "data"], {});
      const { tests = [] } = response;

      const testListToUpdate = tests.map(test => {
        const existingTest = existingTestList.find(t => t.name === test.name);

        if (existingTest) {
          const groupTestsInfoToUpdate = test?.groupTestsInfo || {};
          return {
            ...existingTest,
            ...test,
            groupTestsInfo: {
              ...existingTest.groupTestsInfo,
              ...groupTestsInfoToUpdate
            }
          };
        } else {
          return test;
        }
      });

      return {
        ...state,
        tests: testListToUpdate
      };
    }

    case TEST_MUTE_STATUS_UPDATE: {
      const testList = [...state.tests];
      const { testId = "", isMuted = "" } = action?.payload || {};
      const foundIndex = testList?.findIndex(test => test.id === testId);
      if (foundIndex !== -1) {
        testList[foundIndex].featureFlag.isMuted = isMuted;
      }
      return {
        ...state,
        tests: testList
      };
    }

    default:
      return state;
  }
}
